import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import BreadcrumbNav from '../common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';

function SpecialtyNav({specialty}) {
    const {locale} = useRouter();
    const specialtyName =
        specialty?.department_name || getLocaleContent(locale, 'page.specialty-page.default-specialty');

    const breadcrumbItems = [
        {label: '', href: '/', icon: <HomeOutlined />},
        {
            label: getLocaleContent(locale, 'page.specialty-page.breadcrumb-title'),
            href: '/chuyen-khoa',
            color: '#006940',
        },
    ];

    if (specialty) {
        breadcrumbItems.push({label: specialtyName, href: '#'});
    }

    return (
        <div>
            <BreadcrumbNav items={breadcrumbItems} />
        </div>
    );
}

export default SpecialtyNav;
